import { signal } from "@preact/signals-react"
import { isLoadingCommonFilters } from "./filters"

export const appIntervalId = signal(null)
export const isTourDemoActive = signal(false)

// Functions
export const isLocal = signal(!window.location.host.includes("rentacar."))
export const setAppIntervalId = (func, ts=2000) => appIntervalId.value = setInterval(func, ts)
export const clearAppIntervalId = () => {
	clearInterval(appIntervalId.value)
	appIntervalId.value = null
	if (isLoadingCommonFilters.value)
		isLoadingCommonFilters.value = false
}